module.exports = __webpack_public_path__ + "img/flag-white.d2c2aae6.svg";